// Dutch provinces
export const NL_PROVINCES = [
  { code: 'DR', name: 'Drenthe' },
  { code: 'FL', name: 'Flevoland' },
  { code: 'FR', name: 'Friesland' },
  { code: 'GE', name: 'Gelderland' },
  { code: 'GR', name: 'Groningen' },
  { code: 'LI', name: 'Limburg' },
  { code: 'NB', name: 'Noord-Brabant' },
  { code: 'NH', name: 'Noord-Holland' },
  { code: 'OV', name: 'Overijssel' },
  { code: 'UT', name: 'Utrecht' },
  { code: 'ZE', name: 'Zeeland' },
  { code: 'ZH', name: 'Zuid-Holland' },
];

// Belgian provinces (Flanders + Brussels)
export const BE_PROVINCES = [
  { code: 'VAN', name: 'Antwerpen' },
  { code: 'VLI', name: 'Limburg (BE)' },
  { code: 'VOV', name: 'Oost-Vlaanderen' },
  { code: 'VBR', name: 'Vlaams-Brabant' },
  { code: 'VWV', name: 'West-Vlaanderen' },
  { code: 'BRU', name: 'Brussel' },
];

export const ALL_PROVINCES = [...NL_PROVINCES, ...BE_PROVINCES];

export const getProvinceName = (code) => {
  const province = ALL_PROVINCES.find(p => p.code === code);
  return province ? province.name : code;
};